var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"save"},[_c('div',{staticClass:"automobileMark"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("新建模型")]),_c('img',{attrs:{"src":require("../../assets/wrong.png"),"alt":""},on:{"click":_vm.closeAlert}})]),_c('ModelOne')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }